module.exports = __webpack_public_path__ + "5983c70b3d1eef9215ab4aba5613772b.pdf";